module.exports = __webpack_public_path__ + "img/Diversified.743f5f65.png";